import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { VendorSource } from '@shared-features/enums/vendor-source.enum';
import { BehaviorSubject } from 'rxjs';

export interface VendorConfig {
  vendorSource: string;
  favicon?: string;
  theme?: {
    colors?: any;
  };
}

const TGA_CONFIG: VendorConfig = {
  vendorSource: VendorSource.TGA,
  favicon: 'assets/images/logisti-icon.svg',
  theme: {
    colors: {
      '--color-primary-50': '#e6f4f2',
      '--color-primary-100': '#b3d9d4',
      '--color-primary-200': '#079455',
      '--color-primary-300': '#4da19b',
      '--color-primary-400': '#079455',
      '--color-primary-500': '#074D31',
      '--color-primary-600': '#032b1c',
      '--color-primary-700': '#01272b',
      '--color-primary-800': '#011f24',
      '--color-primary-900': '#001616',
      '--color-primary-A100': '#7afff2',
      '--color-primary-A200': '#2bffe6',
      '--color-primary-A400': '#00e6cc',
      '--color-primary-A700': '#00b3a3',
      '--color-accent-50': '#ecfdf3',
      '--color-accent-100': '#b3d9d4',
      '--color-accent-200': '#079455',
      '--color-accent-300': '#4da19b',
      '--color-accent-400': '#079455',
      '--color-accent-500': '#074D31',
      '--color-accent-600': '#032b1c',
      '--color-accent-700': '#01272b',
      '--color-accent-800': '#011f24',
      '--color-accent-900': '#001616',
      '--color-accent-A100': '#7afff2',
      '--color-accent-A200': '#2bffe6',
      '--color-accent-A400': '#00e6cc',
      '--color-accent-A700': '#00b3a3',
    },
  },
};

const TENANT_CONFIGS: Record<string, VendorConfig> = {
  ...environment.tgaHostNames.reduce((acc: Record<string, VendorConfig>, value: string) => {
    acc[value] = TGA_CONFIG;
    return acc;
  }, {} as Record<string, VendorConfig>),
  'customer.madar.app': {
    vendorSource: VendorSource.Madar,
  },
};
@Injectable({
  providedIn: 'root',
})
export class VendorConfigService {
  readonly vendorConfig$ = new BehaviorSubject<VendorConfig>(null);

  constructor(@Inject(DOCUMENT) private document: Document) {}

  init(): void {
    const host = window.location.hostname;
    const config = TENANT_CONFIGS[host];
    this.vendorConfig$.next(config);

    if (this.vendorConfig$.value && this.vendorConfig$.value?.vendorSource !== VendorSource.Madar) {
      if (this.vendorConfig$.value?.favicon) {
        this.setFavicon(this.vendorConfig$.value?.favicon);
      }

      if (this.vendorConfig$.value?.theme) {
        this.setupTheme();
      }
    }
  }

  private setupTheme(): void {
    Object.keys(this.vendorConfig$.value.theme).forEach((key) => {
      Object.entries(this.vendorConfig$.value.theme[key]).forEach(([key, value]) =>
        document.documentElement.style.setProperty(key, value as any)
      );
    });
  }

  private setFavicon(iconUrl: string): void {
    const link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconUrl;
    this.document.getElementsByTagName('head')[0].appendChild(link);
  }
}
